const useGetTimezoneListDto = async (
  variables?: GetTimezoneListQueryVariables,
  options?: GraphqlQueryOptions<GetTimezoneListQuery, GetTimezoneListQueryVariables>,
) => {
  const query = await useGraphqlQuery(GetTimezoneListSchema, variables, options);
  const list = computed(() => query.result.value?.info?.timezones?.list ?? null);

  return {
    ...query,
    list,
  };
};

export { useGetTimezoneListDto };
